/* eslint-disable react/no-unescaped-entities */
import React, { memo } from 'react';

function Overall() {
  return (
    <div className="complexity-overall-pdf" id="overall">
      {/* <h2>overall complexity</h2> */}
      <h2>Overall Complexity</h2>
      <pre>
        The Deal Complexity Output will provide in-depth information based on
        your Diagnostic Questionnaire selections. Jump into each of the
        completed sections to learn about complexity considerations and
        potential strategies to mitigate risk. Feel free to type in insights and
        customize the language as you prefer for your client conversations by
        clicking the "EDIT" button. You can navigate from section-to-section by
        click the “NEXT” button at the bottom of the page or expanding the left
        pane using the “menu” icon in the top left corner.
      </pre>
    </div>
  );
}

export default memo(Overall);
